<template>
  <a-layout-sider class="sider">
    <a-menu v-model:selectedKeys="selectedKeys" mode="inline" class="menu">
      <a-menu-item v-for="item in menuItems" :key="item.key" style="text-align: left;">
        <component :is="item.icon" /> {{ item.label }}
      </a-menu-item>
    </a-menu>
  </a-layout-sider>
  <a-layout class="content-scroll">
    <southbound-leaderboard />
  </a-layout>
</template>

<script setup>
import { ref } from 'vue';
import { TrophyOutlined } from '@ant-design/icons-vue';

import SouthboundLeaderboard from './SouthboundLeaderboard.vue';

const selectedKeys = ref(['1']);

const menuItems = [
  { key: '1', icon: TrophyOutlined, label: '共建榜单' },
];
</script>

<style scoped>
.sider {
  box-shadow: 2px 0 8px #f0f1f2;
}

.menu {
  height: 100%;
}

.content-scroll {
  padding: 0 24px 24px;
  overflow-y: auto;
  flex: 1;
  background: #F9FAFB;
}
</style>
